<template>
  <div id="app">
    <router-view/>
    <Footer></Footer>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Footer from "@/components/Footer";
import VueMatomo from "vue-matomo";
import Fingerprint2 from 'fingerprintjs2';
import BasicComponent from "@/components/BasicComponent";

@Component({
  components: {Footer}
})
export default class App extends BasicComponent {
  created() {
    //new Fingerprint2({detectScreenOrientation: false}).get(this.onFingerprintReady);

    this.setupAnalytics();
  }

  setupAnalytics() {
    const router = this.$router;

    Vue.use(VueMatomo, {
      siteId: 8,
      host: "https://analytics.gngn.at",
      router: router,
      disableCookies: true,
    });
    // Do not use GA anymore
    return;
    Vue.use(VueAnalytics, {
      id: isAt() ? 'UA-130886953-1' : 'UA-130886953-2',
      /*
      fields: {
          clientId: result,
          storage: "none"
      },
       */
      router,
      autoTracking: {
        screenview: true
      },
      debug: {
        enabled: false, // default value
        trace: false, // default value
        sendHitTask: true // default value
      },
      set: [
        /*
        {
            field: "userId",
            value: result
        },

         */
        {
          field: "anonymizeIp",
          value: true
        }
      ]
    });
  }

  onFingerprintReady(result) {
    const router = this.$router;

    this.track();
  }

  track() {
    this.trackPage("Startseite");
  }
}

function getHost() {
  return window.location.host;
}

function isAt() {
  return window.location.host.toLowerCase().endsWith(".at");
}

document.addEventListener("touchstart", function () {
}, true);

</script>
<style lang="scss">
@import "@/stylesheets/Variables.scss";

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:focus {
    outline: none;
  }
}

html {
  max-width: 100vw;

  position: relative;
  overflow-x: hidden;
  overflow-y: auto;

  font-family: $fontFamily;
}

body {
  background: white no-repeat fixed;

  overflow-x: hidden;
  position: relative;
  min-height: 50vw;
  max-width: 100vw;
  margin: 0;
}

#app {
  text-align: center;
  color: black;
  height: 100%;
  overflow-y: hidden; // Prevent second scroll bar
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  text-align: left;
  font-variant: small-caps;
  font-weight: 900;
}

p {
  margin-top: 0;
  margin-bottom: 0;
}

.fat {
  font-weight: 900;
}

.center {
  margin: 0 auto;
}

a {
  color: black;
}

label {
  margin-right: 100%;
  font-variant: small-caps;
  font-size: 30px;
  font-weight: 900;
  text-align: left;
  white-space: nowrap;
}

input {
  height: 25px;
  width: 100%;
  font-size: 20px;
  border: none;
  border-bottom: 1px solid black;
}

button, .button {
  height: 50px !important;
  width: auto;

  margin: 5px 5px 5px 0;

  border: $speechBubble-border !important;
  background-color: white;
  color: black;

  padding: 0 10px !important;

  $fontSize: 30px !important;
  font-family: $fontFamily !important;
  font-weight: 900 !important;
  font-variant: small-caps !important;
  font-size: $fontSize;
  line-height: $fontSize;
  text-align: center;
  text-indent: unset !important;
  text-transform: none !important;
  letter-spacing: normal !important;

  &.v-btn--disabled {
    border-color: #707070 !important;
    cursor: not-allowed !important;
  }

  &:hover {
    cursor: pointer;
    background-color: black;
    color: white;
  }
}

.modernButton {
  $height: 50px;

  color: white !important;
  background-color: #d7311e !important;
  font-variant: normal !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  font-size: 16px !important;

  height: $height !important;
  border-radius: $height !important;
  border: none !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.dontBreakOut {
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;

  & a {
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
  }
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

</style>
